import { render, staticRenderFns } from "./TimerIcon.vue?vue&type=template&id=4efe853a&"
import script from "./TimerIcon.vue?vue&type=script&lang=js&"
export * from "./TimerIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports